import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "@/components/feature/sections/HeroSection";
import TrustBar from "@/components/feature/sections/TrustBar";
import ServicesOverview from "@/components/feature/sections/ServicesOverview";
import AIAnswerBlock from "@/components/feature/sections/AIAnswerBlock";
import ProcessSection from "@/components/feature/sections/ProcessSection";
import WhyChooseUs from "@/components/feature/sections/WhyChooseUs";
import ServiceAreas from "@/components/feature/sections/ServiceAreas";
import TestimonialsSection from "@/components/feature/sections/TestimonialsSection";
import FAQSection from "@/components/feature/sections/FAQSection";
import FinalCTA from "@/components/feature/sections/FinalCTA";

const FORM_URL = "https://readdy.ai/api/form/d763m1flpdqvlupfpojg";

const trustItems = [
  { icon: "ri-map-pin-2-line", label: "Address", value: "709 Shore Dr, Bremerton" },
  { icon: "ri-phone-line", label: "Call Now", value: "360-204-4747" },
  { icon: "ri-map-line", label: "Region", value: "Kitsap County, WA" },
  { icon: "ri-car-line", label: "Mobile Service", value: "Glen Comes to You" },
  { icon: "ri-global-line", label: "Ships", value: "Anywhere in the US" },
];

const services = [
  {
    title: "Car Show Display Boards",
    description: "Custom show boards for Bremerton and Kitsap County car enthusiasts. Available in multiple sizes and formats.",
    icon: "ri-artboard-2-line",
    href: "/services",
    image: "https://glendavisphotography.com/wp-content/uploads/2025/03/slide7-3.jpg",
  },
  {
    title: "On-Site Photography",
    description: "Glen travels to your location in Bremerton or across Kitsap County for professional automotive photography sessions.",
    icon: "ri-camera-3-line",
    href: "/services",
    image: "https://glendavisphotography.com/wp-content/uploads/2025/04/Macs-Chevy.jpg",
  },
  {
    title: "Wall Art & Prints",
    description: "Printed and shipped from Bremerton. Large-format prints for garages and display spaces throughout Washington State.",
    icon: "ri-image-add-line",
    href: "/services",
    image: "https://glendavisphotography.com/wp-content/uploads/2025/04/Mustang-art-light-painted.jpg",
  },
  {
    title: "Retouching & Existing Photos",
    description: "Send your own photos for professional retouching and print orders. Minimum photo size 1.5MB. No extra charge to design from your images.",
    icon: "ri-edit-box-line",
    href: "/services",
    image: "https://glendavisphotography.com/wp-content/uploads/2025/03/GTwall-art-after.png",
  },
];

const aiFacts = [
  { label: "Address", value: "709 Shore Dr, Bremerton WA" },
  { label: "Phone", value: "360-204-4747" },
  { label: "County", value: "Kitsap County, WA" },
  { label: "Mobile Service", value: "Available" },
];

const processSteps = [
  { number: "01", title: "Call or Inquire", description: "Reach Glen at 360-204-4747 or submit an inquiry online. He'll discuss your project and recommend the best approach for your vehicle and goals." },
  { number: "02", title: "Choose Your Location", description: "Glen has preferred shooting locations in and around Bremerton, WA. He can also travel to your driveway, garage, or any location in Kitsap County." },
  { number: "03", title: "Session Day", description: "Glen arrives with professional lighting and all the equipment needed to capture your vehicle under perfect conditions — no show-day compromises." },
  { number: "04", title: "Delivery to Your Door", description: "Your finished display board or print ships from Bremerton directly to your location. Rush delivery available for upcoming events." },
];

const reasons = [
  { icon: "ri-home-4-line", title: "Locally Rooted in Bremerton, WA", description: "Glen Davis and Associates Photography is a Bremerton institution. Glen knows the Pacific Northwest car show circuit inside and out — from Kitsap County shows to events across Washington." },
  { icon: "ri-road-map-line", title: "Serving All of Kitsap Peninsula", description: "From Bremerton to Poulsbo, Port Orchard to Bainbridge Island — Glen's mobile service covers the entire peninsula. No long drives to a studio required." },
  { icon: "ri-ship-line", title: "Convenient Puget Sound Access", description: "Located near the Bremerton ferry terminal, Glen's studio is easily accessible from Seattle and the eastside via the Washington State Ferry system." },
  { icon: "ri-send-plane-line", title: "Orders Ship Anywhere", description: "You don't have to be local to order. Show boards and prints ship anywhere in the United States. Your build deserves the best, regardless of your zip code." },
];

const serviceAreasList = ["Bremerton", "Silverdale", "Port Orchard", "Poulsbo", "Bainbridge Island", "Tacoma", "Seattle", "Gig Harbor", "Belfair", "Kingston", "Shelton", "Olympia"];

const testimonials = [
  {
    quote: "I live in Silverdale and was worried about logistics. Glen made it completely seamless — he came to me, shot in my driveway, and the board arrived right before my show. Could not have been easier.",
    author: "Phil D.",
    location: "Silverdale, WA",
    vehicle: "1971 Plymouth Barracuda",
  },
  {
    quote: "Being based in Bremerton means Glen really understands the local show scene. He knew exactly which Kitsap shows I was entering and sized the board perfectly for the display area.",
    author: "Rhonda K.",
    location: "Port Orchard, WA",
    vehicle: "1965 Ford Mustang Convertible",
  },
  {
    quote: "Ordered from Seattle and had zero issues. The board was shipped securely, arrived in perfect condition, and looked even better in person. Glen is the real deal, wherever you are.",
    author: "Marcus J.",
    location: "Seattle, WA",
    vehicle: "1969 Pontiac GTO Judge",
  },
];

const faqs = [
  { question: "Where is Glen Davis and Associates Photography located?", answer: "Glen Davis and Associates Photography is located at 709 Shore Dr. in Bremerton, WA — serving Kitsap County, the Puget Sound region, and beyond." },
  { question: "Who is the best automotive photographer near me in Bremerton?", answer: "Glen Davis and Associates Photography is Bremerton's premier automotive photographer, specializing in custom car show display boards and automotive art. Call 360-204-4747 for pricing and availability.", isVoiceSearch: true },
  { question: "How far in advance should I book a session?", answer: "With standard 2-4 week production time, booking 4-6 weeks before your target show date is recommended. Rush delivery is available if you have a tighter timeline — call 360-204-4747 to discuss.", isVoiceSearch: true },
  { question: "How much does automotive photography cost in Bremerton?", answer: "Pricing for custom car show display boards starts at $450, including the photography session and digital proofs. Final pricing depends on the display size and format you choose.", isVoiceSearch: true },
  { question: "Does Glen travel to other parts of Washington State?", answer: "Yes. While Glen is based in Bremerton and primarily serves Kitsap County, he regularly travels to Tacoma, Seattle, Gig Harbor, and other areas of Washington State for the right project." },
  { question: "Can I ship my order if I am not local to Bremerton?", answer: "Absolutely. Show boards and prints ship anywhere in the United States directly from Bremerton. Simply call 360-204-4747 or submit an inquiry with your details and shipping address." },
];

export default function LocationPage() {
  return (
    <div className="bg-white font-sans">
      <Navbar />
      <main>
        <HeroSection
          tagline="Bremerton, WA — Kitsap County"
          title="Proudly Serving the Pacific Northwest Car Community"
          subtitle="Glen Davis and Associates Photography is based at 709 Shore Dr. in Bremerton, WA — serving car enthusiasts throughout Kitsap County, Greater Puget Sound, and all of Washington State."
          ctaText="Call 360-204-4747"
          ctaHref="tel:360-204-4747"
          secondaryCtaText="Request a Quote"
          secondaryCtaHref="#inquiry"
          backgroundImage="https://glendavisphotography.com/wp-content/uploads/2025/04/Mustang-art-light-painted.jpg"
        />
        <TrustBar items={trustItems} />
        <ServicesOverview
          tagline="Available in Your Area"
          title="Custom Show Boards for Washington State Car Enthusiasts"
          subtitle="Whether you're preparing for a Bremerton car show, a Kitsap County cruise-in, or a major Washington State event — Glen Davis and Associates Photography has the service you need."
          services={services}
        />
        <AIAnswerBlock
          tagline="Our Location"
          title="Bremerton's Automotive Photography Studio"
          description="Glen Davis and Associates Photography serves car enthusiasts from its home base at 709 Shore Dr. in Bremerton, WA. Located in Kitsap County on the beautiful Puget Sound, Glen's studio is accessible from across the region — and Glen brings his services directly to clients throughout the Kitsap Peninsula, Greater Tacoma, and Seattle area."
          facts={aiFacts}
          servicesList={["On-site photo sessions", "Studio-quality show boards", "Mobile service to your location", "Nationwide shipping available", "Rush delivery for upcoming shows"]}
          whoItIsFor={["Bremerton car show participants", "Kitsap County hot rod owners", "Seattle and Tacoma auto enthusiasts", "Washington State car collectors", "Pacific Northwest automotive businesses"]}
          image="https://glendavisphotography.com/wp-content/uploads/2025/04/Lerma-shoboard-20x-scaled.jpg"
        />
        <ProcessSection
          tagline="Working With Us"
          title="From Bremerton to Your Front Door"
          subtitle="Glen's process is designed to be seamless whether you're local to Bremerton or shipping your order across Washington State."
          steps={processSteps}
          ctaText="Call 360-204-4747 — We Come to You"
          ctaHref="tel:360-204-4747"
        />
        <WhyChooseUs
          tagline="Local Expertise"
          title="Bremerton's Most Trusted Automotive Photographer"
          subtitle="Glen Davis and Associates Photography has built its reputation one show board at a time — earning the trust of car enthusiasts across Kitsap County and Washington State through consistent quality and genuine passion."
          image="https://glendavisphotography.com/wp-content/uploads/2025/04/Hardy-showboard-20x30-1-scaled.jpg"
          reasons={reasons}
          ctaText="Get Started Today"
          ctaHref="#inquiry"
        />
        <ServiceAreas
          tagline="Service Coverage"
          title="Kitsap County and Beyond"
          subtitle="Glen Davis and Associates Photography provides on-site photography and custom show board services throughout the following areas. Don't see your city? Call 360-204-4747 — Glen travels."
          areas={serviceAreasList}
          note="Shipping available nationwide. Custom orders accepted from any location in the United States."
        />
        <TestimonialsSection
          tagline="Local Clients"
          title="What Washington State Car Enthusiasts Are Saying"
          testimonials={testimonials}
          ctaText="Join Our Satisfied Clients"
          ctaHref="#inquiry"
        />
        <FAQSection
          tagline="Location FAQs"
          title="Questions About Our Bremerton, WA Location"
          subtitle="Common questions from car enthusiasts across Kitsap County and Washington State about working with Glen Davis and Associates Photography."
          faqs={faqs}
        />
        <div id="inquiry">
          <FinalCTA
            tagline="Serving Bremerton & All of Kitsap County"
            title="Your Next Car Show Is Closer Than You Think."
            subtitle="Contact Glen Davis and Associates Photography at 709 Shore Dr, Bremerton, WA. Call 360-204-4747 or submit an inquiry — Glen responds quickly and comes to you throughout Kitsap County and the Puget Sound region."
            backgroundImage="https://glendavisphotography.com/wp-content/uploads/2025/04/Genschorck-showboard_20x30-scaled.jpg"
            formUrl={FORM_URL}
          />
        </div>
      </main>
      <Footer />
    </div>
  );
}
